import React from "react";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";
import { useGlobalState } from "../../../services/context/AuthContext";

interface PriceDetailProps {
  priceInfo: {
    Price: number;
    disc?: number; // Hotel discount
    ewtsoffer?: number; // Optional EWTS offer
    surchargeTotal: number;
    TotalPrice: number;
  };
  roomCount: number;
  nights: number;
}

const RoomPriceDetailCard: React.FC<PriceDetailProps> = ({
  priceInfo,
  roomCount,
  nights,
}) => {
  const {
    Price,
    disc = 0,
    ewtsoffer = 0,
    surchargeTotal,
    TotalPrice,
  } = priceInfo;

  const priceAfterDiscount = Price - disc - ewtsoffer;
  const totalDiscount = disc + ewtsoffer;

  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";

  const discountTooltip = (
    <Box sx={{ p: 1, fontSize: "0.9rem" }}>
      <div className="d-flex justify-content-between">
        <span>
          <CheckCircleOutlineIcon
            color="success"
            fontSize="small"
            className="me-1"
          />
          Hotel Discount
        </span>
        <span> {currency} {disc}</span>
      </div>
      <div className="d-flex justify-content-between mt-1">
        <span>
          <CheckCircleOutlineIcon
            color="success"
            fontSize="small"
            className="me-1"
          />
          EWTS Offer
        </span>
        <span> {currency} {ewtsoffer}</span>
      </div>
    </Box>
  );

  return (
    <div className="card mb-3 mt-3">
      <div className="card-header card-head-bg d-flex align-items-center gap-1">
        <span>Room Price Details</span>
      </div>

      <div className="p-3">
        <div className="d-flex justify-content-between mb-2">
          <div>
            {roomCount} Room{roomCount > 1 ? "s" : ""} X {nights} Night
            {nights > 1 ? "s" : ""}
          </div>
          <div>{currency} {Price.toLocaleString()}</div>
        </div>

        {/* Discount section with tooltip */}
        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex align-items-center gap-1">
            Total Discount
            <Tooltip title={discountTooltip} placement="top" arrow>
              <HelpOutlineIcon fontSize="small" className="text-primary" />
            </Tooltip>
          </div>
          <div className="text-success">
            - {currency} {totalDiscount.toLocaleString()}
          </div>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <div>Price After Discount</div>
          <div>{currency} {priceAfterDiscount.toLocaleString()}</div>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <div>Taxes & Service Fees</div>
          <div>{currency} {surchargeTotal.toLocaleString()}</div>
        </div>

        <div className="d-flex justify-content-between border-top pt-2 mt-2 fw-bold">
          <div>Grand Total</div>
          <div>{currency} {TotalPrice.toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
};

export default RoomPriceDetailCard;
